import React from 'react';
import ATSResumePdf from './ATSResumePdf';
export default function ATSCompactPdf(props) { return <ATSResumePdf {...props} variant="compact" />; }